import {useMediaQuery} from '@malt/joy-entrypoint/src/vue/use';
import {computed} from 'vue';

export function useDisplayMobile() {
    const {matchMedia} = useMediaQuery();
    const isDisplayMobile = computed<boolean>(() => matchMedia.value.max.Sm);

    return {
        isDisplayMobile,
    };
}
